/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from './../useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Trailer-Outline Icon component.
 */
export const AssetTrailerOutlinedIcon = (props: IconProps) => {
  const {color, size = IconSize.large, stroke} = props;
  const {iconSize} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none'>
      <path d="M25.4834 24.625C27.0821 24.625 28.4608 25.8521 28.4609 27.4648C28.4609 29.0777 27.0821 30.3047 25.4834 30.3047C23.8847 30.3047 22.5059 29.0777 22.5059 27.4648C22.506 25.8521 23.8847 24.625 25.4834 24.625Z" stroke={stroke as any} strokeWidth="1.5"/>
      <path d="M9.81213 26.4822L9.76604 26.6023H5.83838C5.5972 26.6029 5.35826 26.5589 5.13525 26.4727C4.91224 26.3866 4.70953 26.26 4.53875 26.1002C4.36798 25.9404 4.23248 25.7506 4.14003 25.5415C4.04758 25.3325 4 25.1085 4 24.8822V12.1688C4 11.7113 4.19369 11.2726 4.53845 10.9491C4.88321 10.6256 5.35081 10.4439 5.83838 10.4439H34.1207C34.3657 10.4381 34.6095 10.4785 34.8376 10.5627C35.0657 10.6468 35.2735 10.773 35.4487 10.9338C35.6239 11.0947 35.763 11.2868 35.8577 11.4989C35.9524 11.711 36.0008 11.9388 36 12.1688V14.0523H35.9832V26.1023C35.9832 26.3784 35.7594 26.6023 35.4832 26.6023H28.542M15.4911 26.6023H22.6295L22.6756 26.4822" stroke={stroke as any} strokeWidth="1.5"/>
      <path d="M12.6289 24.625C14.2276 24.625 15.6063 25.8521 15.6064 27.4648C15.6064 29.0777 14.2276 30.3047 12.6289 30.3047C11.0302 30.3047 9.65137 29.0777 9.65137 27.4648C9.65149 25.8521 11.0303 24.625 12.6289 24.625Z" stroke={stroke as any} strokeWidth="1.5"/>
    </svg>
  );
};

export default AssetTrailerOutlinedIcon;
